import { Grid, Typography } from "@mui/material";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import MxTypography from "@rf-l1/MxTypography";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CDocumentKeys } from "../../../../../../../util/model/documents-types";

const PropertyTitle = () => {
  const {
    validationDocuments: { file_title_property }
  } = useFormValidationsDocumentsMsgSlice();

  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={3.2} alignSelf={"flex-start"}>
    
      <Grid container item xs={12}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyFormKeys.file_title_property}
          label="Título de propiedad"
          maxSize={7}
          minSize={0}
          disabled={file_title_property?.disabled}
          typeKey={CDocumentKeys.Title}
        />
      </Grid>
    </Grid>
  );
};

export default PropertyTitle;
